<main id="db-wrapper" class="bg-light">

  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>

  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">News Insight Detail</h1>
              </div>
            </div>
          </div>
        </div>
        <div class="row gx-3">
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center h-100 justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div class="d-flex justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"

                    ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-12">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card header -->
              <div
                class="card-header align-items-center card-header-height d-flex justify-content-between align-items-center"
              >
                <div style="height: 40px;">
                  <h4 class="mb-0">
                    <div class="skeleton-card"></div>
                  </h4>
                </div>
                <div style="height: 40px;">
                  <div class="skeleton-card"></div>
                </div>
              </div>
              <!-- Card body -->
              <div class="card-body">
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">News Insight Detail</h1>
              </div>
            </div>
          </div>
        </div>
        <section class="py-7 py-lg-8" *ngIf="news!=null">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-12 mb-2">
                <div class="text-center mb-4">

                  <h1 class="display-3 fw-bold mb-4">
                    {{news.title}}
                  </h1>
                  <span class="mb-3 d-inline-block">
                    {{news.pubDate | date: 'dd MMM yyyy, h:mm a'}}
                  </span>
                </div>
                <!-- Media -->
                <div class="d-flex justify-content-between align-items-center mb-5">
                  <div class="d-flex align-items-center">
                    <img src="{{ getFaviconUrl(news.provider)}}" alt="avatar" class="rounded-circle avatar-md" />
                    <div class="ms-2 lh-1">
                      <h5 class="mb-1">{{ getSiteName(news.provider)}}</h5>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <!-- Image -->
              <div class="col-xl-10 col-lg-10 col-md-12 col-12 mb-6">
                <img src="{{news.mediaUrl}}" *ngIf="news.mediaUrl!=null" class="img-fluid rounded-3 w-100" />
              </div>
            </div>
            <div class="row justify-content-center" *ngIf="Ensight!=null">

              <div class="col-lg-12 mb-3">
                <h1>
                  Business Insights
                </h1>
                <!-- custom content -->

               </div>
               <div class="col-lg-3 mb-3">
                <a  class="card card-border-primary rounded-4">
                  <!--card body-->
                  <div class="card-body d-flex flex-column gap-4 text-center">
                    <div>
                      <!--icon-->
                      <div class="icon-shape icon-xxl bg-light-primary rounded-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-gear text-primary" viewBox="0 0 16 16">
                          <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"></path>
                          <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"></path>
                        </svg>
                      </div>
                    </div>
                    <!--content-->
                    <div>
                      <h3 class="mb-0">Is this a Current Trend ?</h3>
                      <p> {{ Ensight.isTrend ? "Yes" : "No" }}</p>
                    </div>
                  </div>
                  </a>
               </div>
               <div class="col-lg-3 mb-3">
                <a  class="card card-border-primary rounded-4">
                  <!--card body-->
                  <div class="card-body d-flex flex-column gap-4 text-center">
                    <div>
                      <!--icon-->
                      <div class="icon-shape icon-xxl bg-light-primary rounded-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-gear text-primary" viewBox="0 0 16 16">
                          <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"></path>
                          <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"></path>
                        </svg>
                      </div>
                    </div>
                    <!--content-->
                    <div>
                      <h3 class="mb-0">Is this a Competitor Activity?</h3>
                      <p> {{ Ensight.isCompetitorActivity ? "Yes" : "No" }}</p>
                    </div>
                  </div>
                  </a>
               </div>
               <div class="col-lg-3 mb-3">
                <a  class="card card-border-primary rounded-4">
                  <!--card body-->
                  <div class="card-body d-flex flex-column gap-4 text-center">
                    <div>
                      <!--icon-->
                      <div class="icon-shape icon-xxl bg-light-primary rounded-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-gear text-primary" viewBox="0 0 16 16">
                          <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"></path>
                          <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"></path>
                        </svg>
                      </div>
                    </div>
                    <!--content-->
                    <div>
                      <h3 class="mb-0">Is this a Regulatory Change?</h3>
                      <p> {{ Ensight.isRegulatoryChange ? "Yes" : "No" }}</p>
                    </div>
                  </div>
                  </a>
               </div>
               <div class="col-lg-6 mb-3">
                <h3>
                  Key Phrases
                </h3>
                <div class="list-group">
                  <a  class="list-group-item list-group-item-action " *ngFor="let item of Ensight.keyPhrases" >
                    <div class="d-flex w-100 justify-content-between">
                      <h4 class="mb-1">
                        {{item}}
                      </h4>
                    </div>
                  </a>

                </div>
               </div>
               <div class="col-lg-6 mb-3">
                <h3>
                  Entities
                </h3>
                <div class="list-group">
                  <a  class="list-group-item list-group-item-action " *ngFor="let item of Ensight.entities" >
                    <div class="d-flex w-100 justify-content-between">
                      <h4 class="mb-1">
                        {{item}}
                      </h4>
                    </div>
                  </a>

                </div>
               </div>
            </div>
          </div>

        </section>
    </div>
    </div>
  </section>
</main>
<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
